export const FULFILL_TEAM = 'team.FULFILL';
export const ADD_TEAM = 'team.ADD';
